module.exports = __webpack_public_path__ + "media/images/homes/Services-27db1a79e68448f3abd170749ac18994.png";